/* eslint-disable */ 
import React from "react";
import { downloadBrowserCSV } from "../lib/download";
import * as Datetime from "react-datetime";
import Select from "react-select";
import NumberInput from "react-number-input";
import _ from "lodash";
import {
  dateFormat,
  timeFormat,
  setClientDateFormat,
  setClientDateTimeFormat,
  setServerDateFormat,
  flatten,
  evalOptions
} from "../utility";
import {
  Container,
  Center,
  Bottom,
  RightGroupList,
  RightGroup,
  RightGroupVertical,
  BottomDirection,
  ReportHeader,
  FormTable,
  FormTd,
  FormTr,
  FormLabel,
  FormInputText,
  FormInputCheck,
  FormTextArea,
  FormIcon,
  FormButton,
  Picker,
  TableView,
  DatetimeRenderers,
  getHeaders,
  DTPicker
} from "./Base";
import { findPaths } from '../lib/helpers';
import NewTable from './NewTable';

class Filters extends React.Component {
  constructor(props) {
    super(props);
    // console.log("constructor");
    const id = props.id;
    const report = props.Session.RX_Report.withId(id);
    const formConfig = report.config.filters;
    const currentData = report.filterdata;
    formConfig.columns.map((item, index) => {
      switch (item.type) {
        case "SelectQuery":
        case "MultiSelectQuery":
          // if (currentData[item.field]) {
          this.props.task_request({
            action: "initlist",
            payload: {
              field: id + item.field,
              values: [currentData[item.field]]
            },
            success: result => {
              let columns = formConfig.columns.slice();
              columns[index].options = result;
              return this.props.upsert({
                model: "RX_Report",
                payload: {
                  id: id,
                  config: Object.assign(
                    {},
                    this.props.Session.RX_Report.withId(id).config,
                    {
                      filters: Object.assign({}, formConfig, {
                        columns
                      })
                    }
                  )
                }
              });
            }
          });
          // }
          break;
        default:
          break;
      }
      return item;
    });
  }
  render() {
    const id = this.props.id;
    const report = this.props.Session.RX_Report.withId(id);
    const formConfig = report.config.filters;
    const databaseData = report.config.filterdata;
    const currentData = report.filterdata;
    if (!formConfig || !databaseData) {
      return <div> {"Veri yükleniyor..."} </div>;
    }
    return (
      <FormTable>
        <tbody>
          {formConfig.columns.map((item, index) => (
            <FormTr key={index}>
              <FormTd>
                <FormLabel>{item.label}</FormLabel>
              </FormTd>
              <FormTd>
                {item.type === "Text" && (
                  <FormInputText
                    value={
                      currentData[item.field] ? currentData[item.field] : ""
                    }
                    name={item.label}
                    onChange={e =>
                      this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: e.target.value
                          })
                        }
                      })
                    }
                  />
                )}
                {item.type === "Bool" && (
                  <FormInputCheck
                    checked={currentData[item.field]}
                    onChange={e => {
                      return this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: e.target.checked
                          })
                        }
                      });
                    }}
                  />
                )}
                {item.type === "Currency" && (
                  <NumberInput
                    value={currentData[item.field]}
                    name={item.label}
                    onChange={(value, e) =>
                      this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: value
                          })
                        }
                      })
                    }
                  />
                )}
                {item.type === "Textarea" && (
                  <FormTextArea
                    value={currentData[item.field]}
                    onChange={e =>
                      this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: e.target.value
                          })
                        }
                      })
                    }
                  />
                )}
                {item.type === "Date" && (
                  <DTPicker
                    utc={true}
                    timeFormat={false}
                    dateFormat={dateFormat}
                    closeOnSelect={true}
                    value={setClientDateFormat(currentData[item.field])}
                    onChange={result =>
                      this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: setServerDateFormat(result) //result.format(dateFormat)
                          })
                        }
                      })
                    }
                  />
                )}
                {item.type === "DateTime" && (
                  <DTPicker
                    utc={true}
                    timeFormat={timeFormat}
                    dateFormat={dateFormat}
                    closeOnSelect={true}
                    value={setClientDateTimeFormat(currentData[item.field])}
                    onChange={result =>
                      this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: setServerDateFormat(result)
                          })
                        }
                      })
                    }
                  />
                )}
                {item.type === "DateWeekOfMonth" && (
                  <div style={{ display: "flex" }}>
                    <Datetime
                      utc={true}
                      renderDay={DatetimeRenderers.renderDay}
                      timeFormat={false}
                      dateFormat={dateFormat}
                      closeOnSelect={true}
                      value={setClientDateFormat(currentData[item.field.first])}
                      onChange={first => {
                        let second = first
                          .clone()
                          .endOf("month")
                          .isBefore(first.clone().add(6, "days"))
                          ? first.clone().endOf("month")
                          : first.clone().add(6, "days");
                        // return this.props.onChangeCombined({
                        //   first: setServerDateFormat(first),
                        //   second: setServerDateFormat(second)
                        // });
                        return this.props.upsert({
                          model: "RX_Report",
                          payload: {
                            id: id,
                            filterdata: Object.assign({}, currentData, {
                              [item.field.first]: setServerDateFormat(first),
                              [item.field.second]: setServerDateFormat(second)
                            })
                          }
                        });
                      }}
                    />
                    <label
                      style={{
                        fontSize: "14px",
                        margin: "auto",
                        marginLeft: "5px"
                      }}
                    >
                      {currentData[item.field.second]
                        ? "-" +
                        setClientDateFormat(currentData[item.field.second])
                        : ""}
                    </label>
                  </div>
                )}
                {item.type === "DateInterval" && (
                  <div>
                    <DTPicker
                      utc={true}
                      timeFormat={false}
                      dateFormat={dateFormat}
                      closeOnSelect={true}
                      value={setClientDateFormat(currentData[item.field.first])}
                      isValidDate={first =>
                        currentData[item.field.second]
                          ? first.isSameOrBefore(currentData[item.field.second])
                          : true
                      }
                      onChange={result =>
                        this.props.upsert({
                          model: "RX_Report",
                          payload: {
                            id: id,
                            filterdata: Object.assign({}, currentData, {
                              [item.field.first]: setServerDateFormat(result)
                            })
                          }
                        })
                      }
                    />
                    <DTPicker
                      utc={true}
                      timeFormat={false}
                      dateFormat={dateFormat}
                      closeOnSelect={true}
                      value={setClientDateFormat(
                        currentData[item.field.second]
                      )}
                      isValidDate={second =>
                        currentData[item.field.first]
                          ? second.isSameOrAfter(currentData[item.field.first])
                          : true
                      }
                      onChange={result =>
                        this.props.upsert({
                          model: "RX_Report",
                          payload: {
                            id: id,
                            filterdata: Object.assign({}, currentData, {
                              [item.field.second]: setServerDateFormat(result)
                            })
                          }
                        })
                      }
                    />
                  </div>
                )}
                {item.type === "DateTimeInterval" && (
                  <div>
                    <DTPicker
                      utc={true}
                      timeFormat={timeFormat}
                      dateFormat={dateFormat}
                      closeOnSelect={true}
                      value={setClientDateTimeFormat(
                        currentData[item.field.first]
                      )}
                      isValidDate={first =>
                        currentData[item.field.second]
                          ? first.isSameOrBefore(currentData[item.field.second])
                          : true
                      }
                      onChange={result =>
                        this.props.upsert({
                          model: "RX_Report",
                          payload: {
                            id: id,
                            filterdata: Object.assign({}, currentData, {
                              [item.field.first]: setServerDateFormat(result)
                            })
                          }
                        })
                      }
                    />
                    <DTPicker
                      utc={true}
                      timeFormat={timeFormat}
                      dateFormat={dateFormat}
                      closeOnSelect={true}
                      value={setClientDateTimeFormat(
                        currentData[item.field.second]
                      )}
                      isValidDate={second =>
                        currentData[item.field.first]
                          ? second.isSameOrAfter(currentData[item.field.first])
                          : true
                      }
                      onChange={result =>
                        this.props.upsert({
                          model: "RX_Report",
                          payload: {
                            id: id,
                            filterdata: Object.assign({}, currentData, {
                              [item.field.second]: setServerDateFormat(result)
                            })
                          }
                        })
                      }
                    />
                  </div>
                )}
                {item.type === "SelectIcon" && (
                  <Picker
                    Icon={currentData[item.field]}
                    SetIcon={icon =>
                      this.props.upsert({
                        model: "RX_Report",
                        payload: {
                          id: id,
                          filterdata: Object.assign({}, currentData, {
                            [item.field]: icon
                          })
                        }
                      })
                    }
                  />
                )}
                {(item.type === "SelectQuery" ||
                  item.type === "MultiSelectQuery" ||
                  item.type === "SelectList" ||
                  item.type === "MultiSelectList") && (
                    <Select
                      multi={
                        item.type === "MultiSelectList" ||
                          item.type === "MultiSelectQuery"
                          ? true
                          : false
                      }
                      value={currentData[item.field]}
                      options={evalOptions(item.options)}
                      onChange={result => {
                        // console.log("onChange:", result);
                        this.props.upsert({
                          model: "RX_Report",
                          payload: {
                            id: id,
                            filterdata: {
                              ...currentData,
                              [item.field]: !result
                                ? null
                                : item.type === "MultiSelectList" ||
                                  item.type === "MultiSelectQuery"
                                  ? result.map(item => item.value)
                                  : result.value
                            }
                          }
                        });
                      }}
                      onInputChange={
                        item.type === "SelectQuery" ||
                          item.type === "MultiSelectQuery"
                          ? _.debounce(val => {
                            // if (!val) return;
                            val = val ? val : "";
                            return this.props.task_request({
                              action: "selectlist",
                              payload: {
                                field: id + item.field,
                                values: ["%" + val + "%"]
                              },
                              success: result => {
                                // console.log("onInputChange:", result);
                                let config = this.props.Session.RX_Report.withId(
                                  id
                                ).config;
                                let filters = config.filters;
                                let columns = filters.columns.slice();
                                columns[index].options = result;
                                return this.props.upsert({
                                  model: "RX_Report",
                                  payload: {
                                    id: id,
                                    config: {
                                      ...config,
                                      filters: {
                                        ...filters,
                                        columns: columns
                                      }
                                    }
                                  }
                                });
                              }
                            });
                          }, 500)
                          : undefined
                      }
                    />
                  )}
              </FormTd>
              <FormTd>
                <FormIcon
                  className="fa fa-undo"
                  onClick={() =>
                    this.props.upsert({
                      model: "RX_Report",
                      payload: {
                        id: id,
                        filterdata: Object.assign({}, currentData, {
                          [item.field]: databaseData[item.field]
                        })
                      }
                    })
                  }
                />
              </FormTd>
            </FormTr>
          ))}
        </tbody>
      </FormTable>
    );
  }
}

export class Grid extends React.Component {
  constructor(props) {
    super(props);
    const id = this.props.id;
    const report = this.props.Session.RX_Report.withId(id);
    let offset = 0;
    if (
      report.config.filters.columns.filter(
        filter => filter.label === "Offset"
      ) &&
      report.config.filters.columns.filter(
        filter => filter.label === "Offset"
      )[0]
    ) {
      offset =
        report.config.filterdata[
        report.config.filters.columns.filter(
          filter => filter.label === "Offset"
        )[0].field
        ];
    }
    this.state = { isFiltersOpen: false, offset };
  }
  refetch({ offset }) {
    const id = this.props.id;
    const report = this.props.Session.RX_Report.withId(id);
    const values = Object.keys(report.filterdata)
      .sort((a, b) => Number(a.substr(1)) - Number(b.substr(1)))
      .map(key => report.filterdata[key]);
    // console.log("refetch", [...values, this.state.limit, this.state.offset]);
    let filterDescription = '';
    const columns = report.config.filters.columns;
    Object.keys(report.filterdata).forEach(item => {
      const field = columns.find(x => x.field === item)
      if (field) {
        filterDescription += `${field.label}: ${report.filterdata[item]}, `
      } else {
        const firstField = columns.find(x => x.field.first === item)
        if(firstField) {
          filterDescription += `${firstField.label} (${firstField.field.first}): ${report.filterdata[item]}, `
        }
        const secondField = columns.find(x => x.field.second === item)
        if(secondField) {
          filterDescription += `${secondField.label} (${secondField.field.second}): ${report.filterdata[item]}, `
        }
      }
    })

    const fullPath = findPaths(this.props, this.props.match.params.name)

    /*
    values: [
          ...values.slice(0, -1),
          offset !== undefined && offset !== null && offset >= 0
            ? offset
            : this.state.offset
        ],
     */

    this.props.task_request({
      action: "browserselect",
      payload: {
        field: id,
        values: [...values],
        fullPath,
        description: filterDescription,
        name: report.name,
        url: window.location.href,
        datasource: report.datasource
      },
      success: result => {
        // console.log("after refetch", result.data);

        this.setState(prevState => ({
          offset:
            offset !== undefined && offset !== null && offset >= 0
              ? offset
              : this.state.offset
        }));
        return this.props.upsert({
          model: "RX_Report",
          payload: {
            id: id,
            data: result.data
          }
        });
      }
    });
  }
  getRowData(columns, row) {
    return columns.map((item, index) => {
      switch (item.type) {
        case "Text":
          return row[item.field];
        case "Date":
          return setClientDateFormat(row[item.field]);
        case "DateTime":
          return setClientDateTimeFormat(row[item.field]);
        case "List":
          return Array.isArray(row[item.field])
            ? row[item.field].map(subRow => this.getRowData(columns, subRow))
            : row[item.field];
        default:
          return row[item.field];
      }
    });
  }
  getHeaderData(row) {
    if (row && Array.isArray(row))
      return row.map(header => {
        if (header.col > 1) {
          let empty = new Array(header.col - 1).fill("");
          return [header.label].concat(empty);
        } else {
          return header.label;
        }
      });
    else return row;
  }
  print({ limit, offset }) {
    const id = this.props.id;
    const report = this.props.Session.RX_Report.withId(id);
    const config = report.config.browser;
    const values = Object.keys(report.filterdata)
      .sort((a, b) => Number(a.substr(1)) - Number(b.substr(1)))
      .map(key => report.filterdata[key]);
    this.props.task_request({
      action: "browserselect",
      payload: {
        field: id,
        values: [...values.slice(0, -2), limit, offset],
        datasource: report.datasource || 1
      },
      success: result => {
        let headers = getHeaders({
          value: report.config,
          viewData: report.data.rows
        });
        headers = headers.map(row => {
          let res = flatten(this.getHeaderData(row));
          return res;
        });
        let data = result.data.rows.map(row =>
          flatten(this.getRowData(config.columns, row))
        );
        /////////////////////////
       /*
        downloadXLSX({
          data,
          headers,
          filename: "report.xlsx"
        })
        */
        downloadBrowserCSV({
          data,
          headers,
          filename: "report.csv"
        });
        
        return this.props.noop({});
      }
    });
  }
  save() {
    const id = this.props.id;
    const report = this.props.Session.RX_Report.withId(id);
    const fullPath = findPaths(this.props, this.props.match.params.name);
    // const values = Object.keys(report.filterdata)
    //   .sort((a, b) => Number(a.substr(1)) - Number(b.substr(1)))
    //   .map(key => report.filterdata[key]);
    // console.log("refetch", values);
    // console.log("save işlemi,", report.filterdata);
    this.props.task_request({
      action: "savefilters",
      payload: {
        field: id,
        values: [JSON.stringify(report.filterdata)],
        fullPath,
        name: report.name,
        url: window.location.href
      },
      success: result => {
        // console.log("after refetch", result);
        return this.props.noop({});
      }
    });
  }
  toggleFilters() {
    this.setState(prevState => ({
      isFiltersOpen: !prevState.isFiltersOpen
    }));
  }
  render() {
    const id = this.props.id;
    const report = this.props.Session.RX_Report.withId(id);
    // const config = report.config.browser;

    let limit = 10;
    if (
      report.config.filters.columns.filter(
        filter => filter.label === "Limit"
      ) &&
      report.config.filters.columns.filter(
        filter => filter.label === "Limit"
      )[0]
    ) {
      limit =
        report.config.filterdata[
        report.config.filters.columns.filter(
          filter => filter.label === "Limit"
        )[0].field
        ];
    }

    if (!report) {
      return <div> {"Veri yükleniyor..."} </div>;
    } else if (!Object.keys(report.config).length || !report.data) {
      return <div>{report.name}</div>;
    }
    const data = report.data;
    const viewData = data.rows; //data.rows.slice(start, start + limit);
    // const total = report.data.rows.length;
    return (
      <Container
        Rows={"auto 60px"}
        Areas={'"browsercenter" "browserbottom"'}
        style={{ height: "calc(100vh - 40px)" }}
      >
        <Center Area={"browsercenter"}>
          <RightGroupList>
            <div style={{ display: "flex" }}>
              <FormButton
                style={{ width: "100px", marginLeft: "15px" }}
                onClick={e => this.toggleFilters()}
              >
                {"Filters"}
              </FormButton>
              <ReportHeader style={{ flexGrow: "1" }}>
                {report.name}
              </ReportHeader>
              <FormButton
                style={{ width: "70px" }}
                onClick={e => this.refetch({ offset: 0 })}
              >
                {"Run"}
              </FormButton>
              { 
                report.config.queries.browserselect && !report.config.queries.browserselect.isProcedure && (
                  <FormButton style={{ width: "70px" }} onClick={e => this.save()}>
                    {"Save"}
                  </FormButton>
                )
              }
            </div>
            <RightGroup
              style={{ display: this.state.isFiltersOpen ? "flex" : "none" }}
            >
              <Filters {...this.props} />
            </RightGroup>
            <RightGroupVertical>
              <NewTable id={report.id} {...this.props} />
            </RightGroupVertical>
          </RightGroupList>
        </Center>
        <Bottom Area={"browserbottom"}>
          <div />
          <div>
            <BottomDirection
              className="fa fa-fast-backward"
              title={"First"}
              onClick={e => this.refetch({ offset: 0 })}
            />
            <BottomDirection
              className="fa fa-step-backward"
              title={"Prev"}
              onClick={e =>
                this.refetch({
                  offset: parseInt(this.state.offset, 10) - parseInt(limit, 10)
                })
              }
            />
            <BottomDirection
              className="fa fa-step-forward"
              title={"Next"}
              onClick={e =>
                this.refetch({
                  offset: parseInt(this.state.offset, 10) + parseInt(limit, 10)
                })
              }
            />
            <BottomDirection
              className="fa fa-fast-forward"
              title={"Last"}
              onClick={e =>
                this.refetch({
                  offset: parseInt(this.state.offset, 10) + parseInt(limit, 10)
                })
              }
            />
            <BottomDirection
              className="fa fa-download"
              title={"Download"}
              onClick={e => this.print({ limit: null, offset: 0 })}
            />
          </div>
          <div />
        </Bottom>
      </Container>
    );
  }
}

// POPUP Olarak açılacak...
// <Modal>
//   <Filters {...this.props} />
//   <div style={{ display: "flex", justifyContent: "flex-end" }}>
//     <FormButton
//       style={{ width: "70px" }}
//       onClick={e => this.save()}
//     >
//       {"Save"}
//     </FormButton>
//     <FormButton
//       style={{ width: "70px" }}
//       onClick={e => this.refetch({ offset: 0 })}
//     >
//       {"Run"}
//     </FormButton>
//   </div>
// </Modal>



// WEBPACK FOOTER //
// ./src/components/Grid.js